module.exports = __webpack_public_path__ + "img/nature-68.64aadf44.jpg";